const popupSchool = document.getElementById('popup-school')
const schoolOverlay = document.querySelector('.school-overlay')

function openPopupSchool() {
	popupSchool.style.display = 'block'
	schoolOverlay.style.display = 'block'
}

function closePopupSchool() {
	popupSchool.style.display = 'none'
	schoolOverlay.style.display = 'none'
}
